import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { ReadLotacaoDto } from '@/api.types';

interface ConflitoLotacao {
  id: number;
  lotacao: ReadLotacaoDto;
  mensagem: string;
}

export interface ValidacaoConflitos {
  conflitos: ConflitoLotacao[];
  mensagem: string;
}

interface IMyProps {
  show: boolean;
  handleHide: () => void;
  conflitos: ValidacaoConflitos | null;
}

export default function ModalConflitos({
  show,
  handleHide,
  conflitos,
}: IMyProps) {
  const formatarData = (data: Date | string | undefined): string => {
    if (!data) return 'Não informado';
    const date = typeof data === 'string' ? new Date(data) : data;
    return date.toLocaleDateString('pt-BR');
  };

  const obterNomePessoa = (lotacao: ReadLotacaoDto): string => {
    if (lotacao.defensor?.pessoa?.nome) {
      return lotacao.defensor.pessoa.nome;
    }
    if (lotacao.colaborador?.pessoa?.nome) {
      return lotacao.colaborador.pessoa.nome;
    }
    if (lotacao.estagio?.estagiario?.pessoa?.nome) {
      return lotacao.estagio.estagiario.pessoa.nome;
    }
    return 'Não informado';
  };

  const obterNomeLocal = (lotacao: ReadLotacaoDto): string => {
    if (lotacao.defensoria?.nome) {
      return lotacao.defensoria.nome;
    }
    if (lotacao.nucleo?.nome) {
      return lotacao.nucleo.nome;
    }
    if (lotacao.setor?.nome) {
      return lotacao.setor.nome;
    }
    return 'Não informado';
  };

  return (
    <Modal
      show={show}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      onHide={handleHide}
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Conflitos de Validação
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {conflitos && conflitos.conflitos.length > 0 ? (
          <>
            <p className="mb-3">
              <strong>{conflitos.mensagem}</strong>
            </p>
            <div className="table-responsive">
              <table className="table table-striped table-bordered">
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>Pessoa</th>
                    <th>Local</th>
                    <th>Data Inicial</th>
                    <th>Data Final</th>
                    <th>Mensagem</th>
                  </tr>
                </thead>
                <tbody>
                  {conflitos.conflitos.map((conflito) => (
                    <tr key={conflito.id}>
                      <td>{conflito.id}</td>
                      <td>{obterNomePessoa(conflito.lotacao)}</td>
                      <td>{obterNomeLocal(conflito.lotacao)}</td>
                      <td>{formatarData(conflito.lotacao.data_inicial)}</td>
                      <td>{formatarData(conflito.lotacao.data_final)}</td>
                      <td>
                        <small className="text-danger">{conflito.mensagem}</small>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </>
        ) : (
          <p>Nenhum conflito encontrado.</p>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleHide}>
          Fechar
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

